
angular.module("ainapp")
    .controller("warehouseBinsController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {

            $scope.PageName = "Warehouse";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.Init = function () {
                $scope.Country = {
                    Name: "",
                    EmailId: "",
                    TelNo: "",
                    MobileNo: "",
                    TRNo: "",
                    Code: "",
                    Address: "",
                    Level: 5,
                }

                $scope.load = 0;

            }
            $scope.Init();

            $scope.Parents = [];
            MainService.WarehousesInDropdownByLevel(1).then(function (response) {
                $scope.Parents = response.data;
            })

            $scope.getWarehouseByParent = function () {
                $scope.Parent2s = [];
                MainService.WarehousesInDropdownByParent($scope.Country.WarehouseId).then(function (response) {
                    $scope.Parent2s = response.data;
                })
            }

            $scope.getWarehouseByParent2 = function () {
                $scope.Parent3s = [];
                MainService.WarehousesInDropdownByParent($scope.Country.AreaId).then(function (response) {
                    $scope.Parent3s = response.data;
                })
            }
            

            $scope.getWarehouseByParent3 = function () {
                $scope.Parent4s = [];
                MainService.WarehousesInDropdownByParent($scope.Country.RackId).then(function (response) {
                    $scope.Parent4s = response.data;
                })
            }


            $scope.KendoSource = new kendo.data.DataSource({
                batch: true,
                transport: {
                    read: function (o) {
                        o.data.Level  = 5;
                        MainService.WarehouseInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success({
                                Data: []
                            });
                            toastr.error("NetworkError");
                        })
                    },

                },
                change: function (data) {},
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                           Name: {
                                type: "string",
                                editable: false,
                            }, 
                            Code: {
                                type: "string",
                                editable: false,
                            }, 
                            "Parent.Name": {
                                type: "string",
                                editable: false,
                            },

                        }
                    }
                },
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
                pageSize: 20,
            });

            $scope.KendoGridOptions = {

                editable: false,
                pageable: true,
                toolbar: ["excel"],
                height: 600,
                resizable: true,
                dataSource: $scope.KendoSource,
                pageSize: 20,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                sortable: true,
                scrollable: true,
                filterable: true,
                groupable: false,
                columnMenu: {
                    filterable: false,
                    filterable: true,
                },

                columns: [
                   {
                        field: "Name",
                        title: "Name",
                        headerTemplate: "{{LanguageData.Name}}",
                    },
                    {
                        field: "Code",
                        title: "Code",
                    },
                    {
                        field: "Parent.Name",
                        title: "Group",
                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}",
                        //                        template: "<button class='btn btn-danger btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'>   </button> <button class='btn btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'>{{LanguageData.Edit}}  </button>",

                        template: "<button class=' btn-default btn-sm fa fa-pencil' ng-click='Edit(dataItem)'> </button> <button class=' btn-default btn-sm fa fa-trash'  ng-click='DeleteAccType(dataItem)'></button>  ",
                        width: '80px'
                    },
                    ],
            };

            $scope.Update = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.sync();
            }
            $scope.Cancel = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.cancelChanges();
            }

            $scope.SelectedDataForDelete = {};
            $scope.DeleteAccType = function (data) {
                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $("#deleteModal").modal("show");
                }
            }

            $scope.deleteWithConfirm = function () {
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.DeleteWarehouse($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data == "Success") {
                        $('#deleteModal').modal('hide');
                        toastr.success("Deleted");
                        $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                        $scope.SelectedDataForDelete = {};
                    } else {
                        toastr.error(response.data);
                    }
                    $.LoadingOverlay("hide");
                }, function (err) {
                    toastr.error("Network Error");
                    $scope.load = 0;
                    $.LoadingOverlay("hide");

                });
            }

            $scope.Edit = function (data) {
                $scope.Country = data;
            }


            $scope.AddData = function () {
                if (!$scope.PageAccessInfo.IsAdd && !$scope.Country.Id > 0) {
                    toastr.info("You Dont Have Access To Add Data, Please Contact Admin");
                } else if (!$scope.PageAccessInfo.IsEdit && $scope.Country.Id > 0) {
                    toastr.info("You Dont Have Access To Edit Data, Please Contact Admin");
                } else {
                    if ($scope.Country.Name == "") {
                        toastr.warning("Enter Warehouse");
                    } else {

                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });

                        MainService.AddWarehouse($scope.Country).then(function (response) {
                            if (response.data == "Success") {
                                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
                                toastr.success("Success");
                                $scope.Init();
                            } else {
                                toastr.error(response.data);
                            }
                            $.LoadingOverlay("hide");

                        }, function (err) {
                            toastr.error("Network Error");
                            $.LoadingOverlay("hide");
                        });
                    }
                }
            }

    }])
